export default __webpack_public_path__ + "static/media/error.77747d61.svg";